import { apiHosts } from "@/api/constants/apiHosts";
import type { Substance } from "@/views/substance/substance";
import { NotifyOptionsError, NotifyOptionsSuccess } from "@modernary/mui/components/notifications";
import { apiService, type Paging, type PagingApiAndNotifierConfig } from "@modernary/mui/utils/api";
import { serializeQueryParams } from "@modernary/mui/utils/helpers";

const URL = "substances";
const ENTITY_NAME = "Substance";

const axiosParams = {
  // Set different base URL based on the environment
  baseURL: import.meta.env.VITE_IHEER_API_BASE_URL,
};

const api = apiService<Substance, Paging<Substance>>(apiHosts.IHEER, axiosParams);

/**
 * @param {Object} params Query parameters, varies (TODO improve this)
 * @param {abortCallback} config.abortMethod Callback for when a request has been aborted
 */
const getSubstances = (params: any, config: PagingApiAndNotifierConfig = {}) => {
  //TODO:TS
  const successNotifCb = (options: NotifyOptionsSuccess) => {
    options.hide = true;
    config?.successNotifCb?.(options);
  };
  const errorNotifCb = (options: NotifyOptionsError) => {
    options.fetched = ENTITY_NAME;
    config?.errorNotifCb?.(options);
  };

  const url = config.pagingUrl ? config.pagingUrl : URL;

  return api.getPaged(url, {
    params,
    paramsSerializer: serializeQueryParams,
    abort: config?.abortMethod,
    successNotifCb,
    errorNotifCb,
  });
};

export { getSubstances };

